import { useState } from "react";

type VaccineRow = {
  vaccine: string;
  brand: string;
  batch: string;
  givenOn: string;
  dueDate: string;
};

const COLUMNS: Array<{ key: keyof VaccineRow; header: string }> = [
  { key: "vaccine", header: "Vaccine" },
  { key: "brand", header: "Brand/Mfr" },
  { key: "batch", header: "Batch/Lot No" },
  { key: "givenOn", header: "Given On" },
  { key: "dueDate", header: "Due Date" },
];

const INITIAL_ROWS: VaccineRow[] = [
  { vaccine: "Anti-Rabies", brand: "", batch: "", givenOn: "", dueDate: "" },
  { vaccine: "", brand: "", batch: "", givenOn: "", dueDate: "" },
  { vaccine: "", brand: "", batch: "", givenOn: "", dueDate: "" },
  { vaccine: "", brand: "", batch: "", givenOn: "", dueDate: "" },
];

const CELL_CLASS = "border border-gray-300 print:border-0 px-4 py-2";
const INPUT_CLASS = "w-full p-0 bg-transparent border-none focus:outline-none text-xs";

const isPresetVaccineCell = (rowIndex: number, key: keyof VaccineRow) => rowIndex === 0 && key === "vaccine";

const isRowEmpty = (row: VaccineRow, rowIndex: number) =>
  COLUMNS.every(({ key }) => isPresetVaccineCell(rowIndex, key) || !row[key].trim());

const VaccinationInfo = () => {
  const [rows, setRows] = useState<VaccineRow[]>(INITIAL_ROWS);

  const updateCell = (rowIndex: number, key: keyof VaccineRow, value: string) =>
    setRows((previousRows) =>
      previousRows.map((row, index) => (index === rowIndex ? { ...row, [key]: value } : row)),
    );

  return (
    <table className="w-full border-collapse border border-gray-300 print:border-0">
      <thead>
        <tr>
          {COLUMNS.map(({ key, header }) => (
            <th key={key} className={`${CELL_CLASS} text-left text-xs`}>
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, rowIndex) => (
          /* Blank rows stay editable on screen but take no space on paper. */
          <tr key={rowIndex} className={isRowEmpty(row, rowIndex) ? "print:hidden" : ""}>
            {COLUMNS.map(({ key }) =>
              isPresetVaccineCell(rowIndex, key) ? (
                <td key={key} className={`${CELL_CLASS} text-xs`}>
                  {row.vaccine}
                </td>
              ) : (
                <td key={key} className={`${CELL_CLASS} italic`}>
                  <input
                    type="text"
                    className={INPUT_CLASS}
                    value={row[key]}
                    onChange={(event) => updateCell(rowIndex, key, event.target.value)}
                  />
                </td>
              ),
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default VaccinationInfo;
